import React from 'react'

export const SuccessIllustation = () => {
  return (
    <svg width="248" height="225" viewBox="0 0 248 225" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M40.5318 141.759C2.57831 112.022 3.68071 94.8702 16.5002 54.4999C30.4608 10.5358 71.1414 -0.41711 143.5 16.5001C226.898 35.9982 226.018 63.6458 241 125C255.982 186.354 171.946 233.248 127.5 222.5C83.0545 211.752 87.9737 178.93 40.5318 141.759Z"
        fill="#724DF8"
        fillOpacity="0.15"
      />
      <path
        d="M24.8929 161.521C7.39285 176.521 17.2929 196.321 40.8929 199.521C70.3929 203.521 42.393 146.521 24.8929 161.521Z"
        fill="#724DF8"
        fillOpacity="0.15"
      />
      <circle cx="130" cy="107" r="66" fill="url(#paint0_radial)" />
      <path
        d="M107.443 104.076L127.076 123.709L157.152 93.6328"
        stroke="white"
        strokeWidth="10.8608"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M212.408 49.2585C222.822 31.9115 241.078 19.8519 244.377 31.702C248.258 45.6433 209.988 42.2269 245.313 6.99994"
        stroke="#FC5EFF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="146.5" cy="3.5" r="3.5" fill="#1EF7E7" />
      <circle cx="32.5" cy="58.5" r="4.5" fill="#1EF7E7" />
      <circle cx="221.5" cy="146.5" r="3.5" fill="#1EF7E7" />
      <circle cx="72.5" cy="185.5" r="3.5" fill="#1EF7E7" />
      <path
        d="M30.6694 121.776C30.6694 121.776 20.1802 124.381 16.8377 129.612C14.6854 132.981 16.8215 136.496 14.1809 139.498C11.0605 143.044 2.61846 143.051 2.61846 143.051"
        stroke="#FC5EFF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M177.289 189C177.289 189 179.24 196.891 182.163 201.035C185.805 206.199 194.857 211.07 194.857 211.07"
        stroke="#FC5EFF"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(102.013 76.5063) rotate(54.3653) scale(143.395 221.975)"
        >
          <stop offset="0.187019" stopColor="#6752F7" />
          <stop offset="1" stopColor="#BD30FF" />
        </radialGradient>
      </defs>
    </svg>
  )
}

export const ErrorIllustratiton = () => {
  return (
    <svg width="262" height="213" viewBox="0 0 262 213" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M54.4999 163C27.4269 123.103 37.0406 72.5748 63.5008 39.4998C91.5008 4.5 149.5 -14 194 15.9998C250.525 54.1063 198.018 71.1457 213 132.5C243.892 259.013 82.9998 205 54.4999 163Z"
        fill="#724DF8"
        fillOpacity="0.15"
      />
      <path
        d="M231.102 100.255C209.335 107.832 226.518 150.234 247.102 138.255C277.21 120.734 252.709 92.7345 231.102 100.255Z"
        fill="#724DF8"
        fillOpacity="0.15"
      />
      <path
        d="M12.2091 67.9998C-2.97637 73.3107 -4.42519 98.5151 12.2091 98.5152C46 98.5155 27.2823 62.7281 12.2091 67.9998Z"
        fill="#724DF8"
        fillOpacity="0.15"
      />
      <circle cx="130" cy="111" r="66" fill="url(#paint0_radial)" />
      <path d="M111 130L149 92" stroke="white" strokeWidth="10.8608" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M149 130L111 92" stroke="white" strokeWidth="10.8608" strokeLinecap="round" strokeLinejoin="round" />
      <circle cx="134.5" cy="19.5" r="3.5" fill="#1EF7E7" />
      <circle cx="45.5" cy="40.5" r="4.5" fill="#1EF7E7" />
      <circle cx="220.5" cy="89.5" r="3.5" fill="#1EF7E7" />
      <circle cx="91.5" cy="202.5" r="3.5" fill="#1EF7E7" />
      <path
        d="M201.001 56.2847L231.646 38.5918"
        stroke="#FC5EFF"
        strokeWidth="7.15139"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M225.168 62.7603L207.476 32.1153"
        stroke="#FC5EFF"
        strokeWidth="7.15139"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.8995 146.51L33.6106 114"
        stroke="#FC5EFF"
        strokeWidth="6.80199"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M45.5099 134.611L12.9998 125.9"
        stroke="#FC5EFF"
        strokeWidth="6.80199"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M185 205.888L206.487 191.6"
        stroke="#FC5EFF"
        strokeWidth="5.21493"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M202.887 209.488L188.6 188"
        stroke="#FC5EFF"
        strokeWidth="5.21493"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <defs>
        <radialGradient
          id="paint0_radial"
          cx="0"
          cy="0"
          r="1"
          gradientUnits="userSpaceOnUse"
          gradientTransform="translate(102.013 80.5063) rotate(54.3653) scale(143.395 221.975)"
        >
          <stop offset="0.187019" stopColor="#FF426F" />
          <stop offset="1" stopColor="#FF30D1" />
        </radialGradient>
      </defs>
    </svg>
  )
}
